import React from 'react';
import './CircularButton.css';

class CircularButton extends React.Component {
  

  render() {
    return( 
        <button
            className="moons-circular-button primary"
            onClick={ () => this.props.onClick() }
        >
            <span className={this.props.icon}></span>
        </button>
    )
  }

  
}

export default CircularButton;



// WEBPACK FOOTER //
// ./src/views/Components/Presentation/CircularButton/CircularButton.js